import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="address-book"
export default class extends Controller {
  static targets = ["editButton", "body", "hide"]
  static outlets = ["address-book", "contact", "address-book-contact-delete"]

  link(event) {
    if(event.target.tagName == "SELECT" || event.target.tagName == "INPUT") return

    this.addressBookOutlet.bodyTarget.appendChild(event.currentTarget)
    if(this.addressBookOutlet.hasContactOutlet) this.addressBookOutlet.hideTarget.classList.add("hidden")
    if(!this.hasContactOutlet) this.hideTarget.classList.remove("hidden")
    this.contactController = this.application.getControllerForElementAndIdentifier(event.currentTarget, "contact")

    this[`_${this.element.id == "selected-contacts-table" ? "remove" : "add"}`]( 
      this.contactController.getTargets())
  }

  _add([table_data, elements, destroy_field, _address_book_id, id_field]) {
    table_data.forEach(element => element.classList.remove("hidden"))
    elements.forEach(element => element.removeAttribute("form"))
    destroy_field?.setAttribute("form", "none")
    this.contactController.addressBookSelectedIdTarget.setAttribute("form", "search-contact")
    this.contactController.setDisabledPrimaryCheckbox(false)
    if(this.hasAddressBookContactDeleteOutlet) this.addressBookContactDeleteOutlet.removeDeletedContact(id_field?.value)
  }

  _remove([table_data, elements, destroy_field, _address_book_id, id_field]) {
    table_data.forEach(element => element.classList.add("hidden"))
    elements.forEach(element => element.setAttribute("form", "none"))
    destroy_field?.removeAttribute("form")
    this.contactController.addressBookSelectedIdTarget.setAttribute("form", "none")
    this.contactController.setDisabledPrimaryCheckbox(true)
    if(this.hasAddressBookContactDeleteOutlet) this.addressBookContactDeleteOutlet.addDeletedContact([destroy_field, id_field], id_field?.value)
  }
}
